import React, { memo, useEffect, useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { Button } from '@mui/material';

import useTopPanel from 'hooks/useTopPanel';
import BaseTable from 'components/ui/tables/BaseTable';
import { clientTypeVariants } from 'shared/tableColVariantsList';
import useMenu from 'hooks/useMenu';
import useAuth from 'hooks/useAuth';
import SearchInputNavbar from 'components/SearchInputNavbar';

const Clients = () => {
  const { search } = useLocation();
  const [{ user }] = useAuth();
  const { setComponent } = useTopPanel();
  const { t, i18n } = useTranslation();
  const { hasChild } = useMenu();
  const navigate = useNavigate();
  const [refetch, setRefetch] = useState(false);
  const [open, setOpen] = useState(false);

  const view = (code) => hasChild('CUSTOMS', code);

  const onClickRow = (data) => {
    navigate(`/admin/client/view/${data.id}`);
  };

  useEffect(() => {
    setComponent(<div className='component-title'>{t('client.title')}</div>);
  }, [i18n.language]);

  const newSearch = useMemo(() => {
    if (search?.size > 0) {
      return `?${search?.toString()}&token=${user?.access_token}`;
    }
    return `?token=${user?.access_token}`;
  }, [search, user?.access_token]);

  return (
    <div className='component-list-wrapper'>
      <div className='component-list-header mb-2'>
        <div className='header-actions-container pt-2 pb-2 flex flex-row items-center'>
          <div className='grow'>
            <SearchInputNavbar inputKey='name' fullWidth />
          </div>
          <div className='header-actions action-buttons-box flex items-center justify-center ml-4'>
            <Button
              variant='base'
              onClick={() => {
                setRefetch(true);
              }}
              disable={`${refetch}`}
            >
              <i
                className={`bi bi-arrow-repeat${
                  refetch ? ' animate-spin' : ''
                }`}
              />
            </Button>
            <Link
              to={`${process.env.REACT_APP_BACKEND_URL}/excel/customs${newSearch}`}
              className='no-underline !mx-2'
              // target='_blank'
            >
              <Button variant='base'>
                <i className='bi bi-download' />
              </Button>
            </Link>

            {view('ADD_CUSTOMS') && (
              <Button
                variant='base'
                onClick={() => {
                  navigate('/admin/client/add');
                }}
              >
                <i className='bi bi-plus-circle' />
              </Button>
            )}
            <Button
              variant='base'
              className='!ml-2'
              onClick={() => setOpen(true)}
            >
              <i className='bi bi-gear' />
            </Button>
          </div>
        </div>
      </div>

      <div className='component-table-wrapper h-[calc(100vh-160px)]'>
        <BaseTable
          emitRefetch={{ refetch, setRefetch }}
          dataPath='dictionary/customs'
          emitTableColumns={{ open, setOpen }}
          tableName='clients'
          headCells={[
            { code: 'id', label: '#' },
            { code: 'name', label: t('common.table.personName') },
            { code: 'surname', label: t('common.table.surname') },
            { code: 'middlename', label: t('common.table.middleName') },
            { code: 'phone', label: t('common.table.phone') },
            { code: 'client_type', label: t('common.table.clientType') },
          ]}
          columns={[
            { code: 'id' },
            { code: 'name' },
            { code: 'surname' },
            { code: 'middlename' },
            { code: 'phone' },
            {
              code: 'client_type',
              type: 'customStatus',
              variants: clientTypeVariants,
            },
          ]}
          actionInfo={true}
          onClickRow={onClickRow}
        />
      </div>
    </div>
  );
};

export default memo(Clients);
